import React from 'react';
import {useRouteError} from 'react-router-dom';

import {ErrorState} from './ErrorState';

type Props = {
  children: React.ReactNode;
  resetKey?: string;
};

type State = {
  error: Error | null;
  resetKey?: string;
};

export class ShellErrorBoundary extends React.Component<Props, State> {
  state: State = {error: null};

  static getDerivedStateFromProps(props: Props, state: State): State | null {
    if (props.resetKey !== state.resetKey) {
      return {error: null, resetKey: props.resetKey};
    }
    return null;
  }

  static getDerivedStateFromError(error: Error): State {
    return {error};
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Shell render error', error, info.componentStack);
  }

  render() {
    if (this.state.error != null) {
      return <ErrorState title="Something went wrong." />;
    }

    return this.props.children;
  }
}

export const ShellRouteError = () => {
  const error = useRouteError();
  console.error('Shell route error', error);

  return (
    <div style={{height: '100%'}}>
      <ErrorState title="Something went wrong." />
    </div>
  );
};
